module.exports = __webpack_public_path__ + "static/img/m2.3cb51a6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/spark2/mobile/m2.png
// module id = wthG
// module chunks = 12